<template>
  <v-stepper flat v-model="current" class="stepper">
    <v-stepper-header>
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n}-step`"
            :complete="current > n"
            :step="``"
            :class="[{'active':n === current}, `step-${n}`]"
          >
          <template v-if="n === current">
                {{labels[n-1]}}
          </template>
          </v-stepper-step>
          <v-divider
            v-if="n !== steps"
            :key="n"
          ></v-divider>
        </template>
    </v-stepper-header>
  </v-stepper>
</template>
<script>

export default {
     props:{
          current:Number
     },
    data: ()=> ({
         steps: 5,
         labels:['감정','상황','생각','행동', '계획']
    }),
    components:{

    }
}
</script>
<style lang="scss" scoped>
::v-deep .active{

    &.step-1{
         .v-stepper__step__step{
            background-image: url("~@/assets/images/ic_emotion_01.png") !important;
         }
    }
    &.step-2{
         .v-stepper__step__step{
            background-image: url("~@/assets/images/ic_emotion_02.png") !important;
         }
    }
    &.step-3{
         .v-stepper__step__step{
            background-image: url("~@/assets/images/ic_emotion_03.png") !important;
         }
    }
    &.step-4{
         .v-stepper__step__step{
            background-image: url("~@/assets/images/ic_emotion_04.png") !important;
         }
    }
    &.step-5{
         .v-stepper__step__step{
            background-image: url("~@/assets/images/ic_emotion_05.png") !important;
         }
    }
    
}
</style>